import React from 'react'
import { Head } from '../../component'
import { AdjustAmount } from './components'
import { TrackPageViewed } from '../../integrations/monitoring'
import { CheckoutPage } from '../../model'
import { useApplePayEntryData } from '../../state'
import { useTranslation } from '../../utils/convergence'

export const AdjustAmountPage: CheckoutPage = () => {
  const { t } = useTranslation()
  const pageTitle = t('common:brandName')
  const applePayEntryData = useApplePayEntryData()

  const flowType = applePayEntryData?.flowType

  return (
    <>
      <Head title={pageTitle} />
      <AdjustAmount />
      <TrackPageViewed eventProperties={{ flowType }} />
    </>
  )
}
